import api from "./httpClient";

/**
 * GET /api/HistoryBulk/Counts
 *
 * Zwraca liczbę importów w rozbiciu na statusy — jedno zapytanie GROUP BY zamiast
 * kilku zapytań listujących wykonywanych wyłącznie po to, by odczytać licznik.
 * Odpowiedź: { "-1": 6, "2": 120, "4": 3, ... } — klucze to HistoryBulkStatus.
 *
 * Backend stosuje te same reguły widoczności co lista /data-import
 * (userId dla ROLE_USER, oddziały z X-Branch-Id, wykluczenie Import CSV).
 *
 * @param {AbortSignal} [signal]
 */
export function getDataImportStatusCounts(signal) {
  return api.get("/HistoryBulk/Counts", { signal });
}
